import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class FireExtinguisherTypeLookupModel extends ModelBase<FireExtinguisherTypeLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = FireExtinguisherTypeLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = FireExtinguisherTypeLookupModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = FireExtinguisherTypeLookupModel.DEFAULT_ID;
        this.displayName = FireExtinguisherTypeLookupModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: FireExtinguisherTypeLookupModellDTO): void {
        this.id = dto.id;
        this.displayName = `${dto.displayName}`;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: FireExtinguisherTypeLookupModellDTO[]): FireExtinguisherTypeLookupModel[] {
        const types: FireExtinguisherTypeLookupModel[] = [];

        for (const dto of dtos) {
            const model = new FireExtinguisherTypeLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface FireExtinguisherTypeLookupModellDTO {
    id: string;
    displayName: string;
}
